export default {
    computed: {
      valueIndex() {
        const m = new Map();
        this.dataValues.forEach(o => m.set(o.id, o));
        return m;
      },
    },
    methods: {
      searchVariableValueById(varId) {
        const item = this.valueIndex.get(varId);
        if (item) {
          const value = parseFloat(String(item.value).replace(',', '.'));
          return { value, time: item.datetime };
        }
        return { time: '', value: 0 };
      },
    },
  };
  